import { render, staticRenderFns } from "./CortaCorrienteModal.vue?vue&type=template&id=f81bf136&scoped=true&"
import script from "./CortaCorrienteModal.vue?vue&type=script&lang=ts&"
export * from "./CortaCorrienteModal.vue?vue&type=script&lang=ts&"
import style0 from "./CortaCorrienteModal.vue?vue&type=style&index=0&id=f81bf136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81bf136",
  null
  
)

export default component.exports